__turbopack_context__.v({
  "root": "InlineFilters-MeasurementPlaceholder-module-scss-module__VOfLcG__root",
});
